import clsx from 'clsx';
import firebase from 'firebase/app';
import _ from 'lodash';

import { Icon } from '@iconify/react';
import { useSnackbar } from 'notistack';
import useAuth from 'src/hooks/useAuth';
import { PATH_APP } from 'src/routes/paths';
import MyAvatar from 'src/components/MyAvatar';
import React, { useRef, useState, useEffect } from 'react';
import homeFill from '@iconify-icons/eva/home-fill';
import PopoverMenu from 'src/components/PopoverMenu';
import useIsMountedRef from 'src/hooks/useIsMountedRef';
import personFill from '@iconify-icons/eva/person-fill';
import settings2Fill from '@iconify-icons/eva/settings-2-fill';
import { Link as RouterLink, useHistory } from 'react-router-dom';
import { alpha, makeStyles } from '@material-ui/core/styles';
import { Button, Box, Divider, MenuItem, Typography, Stack, CircularProgress, Dialog, DialogTitle, DialogContent, DialogActions, Grid, IconButton, TextField, InputAdornment } from '@material-ui/core';
import { MIconButton } from 'src/theme';
import bookIcon from '@iconify/icons-akar-icons/book';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash, faTimes } from '@fortawesome/free-solid-svg-icons';

import LogoAvatar from 'src/components/LogoAvatar';
import CompanyAccountAvatar from 'src/components/CompanyAccountAvatar';

import { getListLinkedAccount, addLinkedAccount, removeAccountFromLinked } from 'src/api/linkedAccountDistributor';
import { validateNewAccountSwitchDistributor, getCustomToken } from 'src/api/login';

import DialogLoading from 'src/components/DialogLoading';

const home_url = process.env.REACT_APP_DOMAIN

// ----------------------------------------------------------------------

const MENU_OPTIONS = [
  {
    label: 'Home',
    icon: homeFill,
    linkTo: '/adminKC/dashboard'
  },
  {
    label: 'Terms of Use',
    icon: bookIcon,
    linkTo: '/ChosenTermsCondition'
  },
  {
    label: 'Privacy Policy',
    icon: bookIcon,
    linkTo: '/ChosenPrivacyPolicy'
  },
];

const useStyles = makeStyles((theme) => ({
  btnAvatar: {
    padding: 0,
    width: 44,
    height: 44
  },
  isSelected: {
    '&:before': {
      zIndex: 1,
      content: "''",
      width: '100%',
      height: '100%',
      borderRadius: '50%',
      position: 'absolute',
      background: alpha(theme.palette.grey[900], 0.8)
    }
  }
}));

const textSty01 = {
  color: '#34B467',
  fontSize: 12,
  fontWeight: 'bold',
  cursor: 'pointer'
}
const textSty02 = {
  color: 'black',
  fontSize: 14,
  fontWeight: 'bold'
}
const textSty03 = {
  color: '#A0A0A0',
  fontSize: 12,
  fontWeight: 'bold'
}
const textSty04 = {
  color: 'black',
  fontSize: 14,
  fontWeight: 'bold'
}
const textSty05 = {
  color: 'red',
  fontSize: 10,
  fontWeight: 'bold',
  cursor: 'pointer'
}


// ----------------------------------------------------------------------

function Account() {
  const classes = useStyles();
  const firebaseUser = firebase.auth().currentUser;

  const history = useHistory();
  const anchorRef = useRef(null);
  const { user, logout } = useAuth();
  const isMountedRef = useIsMountedRef();
  const { enqueueSnackbar } = useSnackbar();
  const [isOpen, setOpen] = useState(false);

  // SWITCH ACCOUNT STATES
  const [listAccount, setListAccount] = useState([]);

  const [openSwitchAccountView, setOpenSwitchAccountView] = useState(false);

  const [openAddNewAccountDialog, setOpenAddNewAccountDialog] = useState(false);
  const [inputEmail, setInputEmail] = useState('');
  const [inputPassword, setInputPassword] = useState('');
  const [passwordFieldType, setPasswordFieldType] = useState('password');
  const [inputConfirmPassword, setInputConfirmPassword] = useState('');
  const [confirmPasswordFieldType, setConfirmPasswordFieldType] = useState('password');

  const [addNewAccountLoading, setAddNewAccountLoading] = useState(false);
  
  const [loadingListLinkedAccount, setLoadingListLinkedAccount] = useState(false);

  const [switchLoading, setSwitchLoading] = useState(false);

  // REMOVE ACCOUNT
  const [openRemoveAccountDialog, setOpenRemoveAccountDialog] = useState(false);
  const [removeAccountCompanyName, setRemoveAccountCompanyName] = useState('');
  const [removeAccountUserID, setRemoveAccountUserID] = useState('');
  const [removeLoading, setRemoveLoading] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const handleLogout = async () => {
    try {
      await logout();
      window.location = `${home_url}`;
    } catch (error) {
      console.error(error);
      enqueueSnackbar('Unable to logout', { variant: 'error' });
    }
  };

  
  const handleConfirm = async () => {
    try {
      setAddNewAccountLoading(true);

      // 1. VALIDATE GIVEN NEW ACCOUNT CREDENTIAL
      let sendData = {
        email: inputEmail,
        password: inputPassword
      }
      
      const res = await validateNewAccountSwitchDistributor(sendData);

      if (res.status === 200) {
        const token = await firebaseUser.getIdToken();

        // ADD NEW LINKED ACCOUNT
        const result = await addLinkedAccount(token, {
          currentUserID: user._id,
          currentDistributorID: user.distributorID,
          targetEmail: inputEmail
        })

        if (result.message === "SUCCESS") {
          enqueueSnackbar('Successfully added new account', { variant: 'success' });
          setOpenAddNewAccountDialog(false);
          setAddNewAccountLoading(false);

          await reloadLinkedAccount();
        }
        else if (result.status !== 200 && result.data.message === "ALREADY EXISTS") {
          enqueueSnackbar('Account already exists!', { variant: 'error' });
          setAddNewAccountLoading(false);
        }
        else {
          enqueueSnackbar('Failed to add new account', { variant: 'error' });
          setAddNewAccountLoading(false);
        }
      }
      else {
        enqueueSnackbar("Failed to validate new account", { variant: 'error' });
        setAddNewAccountLoading(false);
      }

    }
    catch (err) {
      enqueueSnackbar("Failed to validate new account", { variant: 'error' });
      setAddNewAccountLoading(false);
    }
  }

  const handleSwitch = async (newFirebaseUID, userType) => {
    try {
      setSwitchLoading(true);
      const getToken = await getCustomToken({
        firebaseUID: newFirebaseUID
      });

      localStorage.setItem('targetUserType', userType);

      await firebase.auth().signInWithCustomToken(getToken.token);
      setSwitchLoading(false);

    }
    catch (err) {
      setSwitchLoading(false);
    }
  }
  
  const handleRemoveAccount = async () => {
    try {
      setRemoveLoading(true)

      const token = await firebaseUser.getIdToken();

      const result = await removeAccountFromLinked(token, {
        userID: removeAccountUserID
      })

      if (result.message === "SUCCESS") {
        setRemoveLoading(false);
        setOpenRemoveAccountDialog(false);
        enqueueSnackbar('Account has been successfully removed!', { variant: 'success' })
        await reloadLinkedAccount();
      }
      else {
        enqueueSnackbar('Failed to remove account', { variant: 'error' })
        setRemoveLoading(false);
      }
    }
    catch (err) {
      enqueueSnackbar('Failed to remove account', { variant: 'error' })
      setRemoveLoading(false);
    }
  }

  const reloadLinkedAccount = async () => {
    try {
      setLoadingListLinkedAccount(true);
      const token = await firebaseUser.getIdToken();
      const listAccountData = await getListLinkedAccount(token, {
        userID: user._id
      })
      setListAccount(listAccountData || []);

      setLoadingListLinkedAccount(false);
    }
    catch (err) {
      console.log(err);
      setLoadingListLinkedAccount(false);
    }
  }

  useEffect(() => {
    const retrieveLinkedAccount = async () => {
      try {
        setLoadingListLinkedAccount(true);
        const token = await firebaseUser.getIdToken();
        const listAccountData = await getListLinkedAccount(token, {
          userID: user._id
        });
        setListAccount(listAccountData || []);
      } catch (err) {
        console.log(err);
      } finally {
        setLoadingListLinkedAccount(false);
      }
    };
  
    retrieveLinkedAccount();
  }, [firebaseUser, user._id]);

  return (
    <>
      <MIconButton
        ref={anchorRef}
        onClick={handleOpen}
        className={clsx(classes.btnAvatar, { [classes.isSelected]: isOpen })}
      >
        <MyAvatar />
      </MIconButton>

      <PopoverMenu
        width={220}
        open={isOpen}
        onClose={handleClose}
        anchorEl={anchorRef.current}
        style={{
          overflowY: 'auto'
        }}
      >
        <Box sx={{ my: 2, px: 2.5 }}>
          <Stack direction="row" spacing={1} sx={{ mb: 1 }}>
            <LogoAvatar />

            <Stack direction="column">
              <Typography variant="body2" sx={{ color: 'text.primary', maxWidth: '125px', overflow: 'hidden', textOverflow: 'ellipsis' }} noWrap>
                {user.firstName}
              </Typography>
              <Typography variant="body2" sx={{ marginTop: '-5px', color: 'text.secondary', maxWidth: '125px', overflow: 'hidden', textOverflow: 'ellipsis', }} noWrap>
                {user.email}
              </Typography>
            </Stack>
          </Stack>

          {
            !openSwitchAccountView && (
              <Typography style={textSty01} onClick={() => setOpenSwitchAccountView(true)}>Switch Account</Typography>
            )
          }
          
        </Box>

        <Divider sx={{ my: 1 }} />


        {
          openSwitchAccountView && (
            <Stack direction="column" spacing={1} sx={{ px: 2.5, py: 1 }}>
              <Typography style={textSty03}>Choose Another Account</Typography>

              {
                loadingListLinkedAccount && <CircularProgress size={35} />
              }

              {
                !loadingListLinkedAccount && !_.isEmpty(listAccount) && listAccount.map((item, index) => {
                  return (
                    <>
                      <Stack 
                        direction="row" 
                        spacing={1} 
                        sx={{ mb: 1, cursor: 'pointer' }} 
                        key={index} 
                        onClick={() => {
                          handleSwitch(item.userID?.firebaseUID, item.userID?.userType)
                        }}
                      >
                        <CompanyAccountAvatar 
                          logo={item.distributorID?.logo ? item.distributorID?.logo[0]?.url : null}
                        />
                        <Stack direction="column">
                          <Typography variant="body2" sx={{ color: 'text.primary', maxWidth: '125px', overflow: 'hidden', textOverflow: 'ellipsis' }} noWrap>
                            {item.distributorID?.companyName || ''}
                          </Typography>
                          <Typography variant="body2" sx={{ marginTop: '-5px', color: 'text.secondary', maxWidth: '125px', overflow: 'hidden', textOverflow: 'ellipsis', }} noWrap>
                            {item.userID?.email || ''}
                          </Typography>
                          <Typography 
                            style={textSty05} 
                            onClick={(e) => {
                              e.stopPropagation();
                              setOpenRemoveAccountDialog(true)
                              setRemoveAccountCompanyName(item.distributorID?.companyName || '')
                              setRemoveAccountUserID(item.userID?._id || '')
                            }}
                          >Remove Account</Typography>
                        </Stack>
                      </Stack>
                      {listAccount.length > 1 && index !== listAccount.length - 1 && <Divider />}
                    </>
                    
                  )
                 
                })
              }

              <Button
                variant="outlined"
                color="inherit"
                onClick={() => {
                  setOpenAddNewAccountDialog(true)
                }}
                fullWidth
              >
                <Typography style={textSty02}>Add Another Account</Typography>
              </Button>
            </Stack>
          )
        }

        {MENU_OPTIONS.map((option) => (
          <MenuItem
            key={option.label}
            to={option.linkTo}
            component={RouterLink}
            onClick={handleClose}
            sx={{ typography: 'body2', py: 1, px: 2.5 }}
          >
            <Box
              component={Icon}
              icon={option.icon}
              sx={{
                mr: 2,
                width: 24,
                height: 24
              }}
            />

            {option.label}
          </MenuItem>
        ))}

        <Box sx={{ p: 2, pt: 1.5 }}>
          <Button
            fullWidth
            color="inherit"
            variant="outlined"
            onClick={handleLogout}
          >
            Logout
          </Button>
        </Box>
      </PopoverMenu>


      {/**DIALOG ADD NEW ACCOUNT - SWITCH */}
      <Dialog open={openAddNewAccountDialog} maxWidth='sm' fullWidth>
        <DialogTitle style={{ paddingTop: 12, paddingBottom: 12 }}>
          <Grid container direction="row" spacing={2} style={{ paddingBottom: 12 }} alignItems="center">
            <Grid item xs={10}>
              <Typography style={textSty04}>Add New Account</Typography>
            </Grid>
            <Grid item xs={2}>
              <IconButton
                style={{
                  float: 'right',
                  padding: 0,
                  fontSize: 20
                }}
                onClick={() => {
                  setOpenAddNewAccountDialog(false)
                }}
              >
                <FontAwesomeIcon icon={faTimes} />
              </IconButton>
            </Grid>
          </Grid>
          <Divider />
        </DialogTitle>
        
        <DialogContent style={{ paddingTop: 12, paddingBottom: 12 }}>
          <Stack direction="column" spacing={2}>
            <TextField
              value={inputEmail}
              onChange={(e) => setInputEmail(e.target.value)}
              label="Email"
              placeholder="Email"
              fullWidth
              variant="outlined"
              error={_.isEmpty(inputEmail)}
              helperText={_.isEmpty(inputEmail) ? <span style={{ color: 'red' }}>Field is required</span> : ''}
              FormHelperTextProps={{
                style: {
                  marginLeft: 0
                }
              }}
            />

            <TextField
              value={inputPassword}
              onChange={(e) => setInputPassword(e.target.value)}
              label="Password"
              placeholder="Password"
              fullWidth
              variant="outlined"
              type={passwordFieldType}
              error={_.isEmpty(inputPassword)}
              helperText={_.isEmpty(inputPassword) ? <span style={{ color: 'red' }}>Field is required</span> : ''}
              FormHelperTextProps={{
                style: {
                  marginLeft: 0
                }
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => {
                        setPasswordFieldType(passwordFieldType === 'password' ? 'text' : 'password')
                      }}
                      style={{
                        padding: 0
                      }}
                    >
                      {
                        passwordFieldType === 'password' ? (
                          <FontAwesomeIcon icon={faEyeSlash} style={{ fontSize: "18px" }}/>
                        )
                        :
                        (
                          <FontAwesomeIcon icon={faEye} style={{ fontSize: "18px" }}/>
                        )
                      }
                    </IconButton>
                  </InputAdornment>
                )
              }}
            />

            <TextField
              value={inputConfirmPassword}
              onChange={(e) => setInputConfirmPassword(e.target.value)}
              label="Confirm Password"
              placeholder="Confirm Password"
              fullWidth
              variant="outlined"
              type={confirmPasswordFieldType}
              error={_.isEmpty(inputConfirmPassword) || (inputPassword !== inputConfirmPassword)}
              helperText={_.isEmpty(inputConfirmPassword) || (inputPassword !== inputConfirmPassword) ? <span style={{ color: 'red' }}>Password does not match</span>: ''}
              FormHelperTextProps={{
                style: {
                  marginLeft: 0
                }
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => {
                        setConfirmPasswordFieldType(confirmPasswordFieldType === 'password' ? 'text' : 'password')
                      }}
                      style={{
                        padding: 0
                      }}
                    >
                      {
                        confirmPasswordFieldType === 'password' ? (
                          <FontAwesomeIcon icon={faEyeSlash} style={{ fontSize: "18px" }}/>
                        )
                        :
                        (
                          <FontAwesomeIcon icon={faEye} style={{ fontSize: "18px" }}/>
                        )
                      }
                    </IconButton>
                  </InputAdornment>
                )
              }}
            />
          </Stack>
        </DialogContent>

        <DialogActions style={{ paddingTop: 16 }}>
          <Grid container direction="row" justifyContent="flex-end" spacing={2}>
            <Grid item xs={3} md={2}>
              <Button
                variant="contained"
                fullWidth
                style={{
                  backgroundColor: addNewAccountLoading ? "grey" : "black"
                }}
                onClick={() => {
                  setOpenAddNewAccountDialog(false)
                }}
                disabled={addNewAccountLoading}
              >
                <Typography style={{ color: "white" }}>Cancel</Typography>
              </Button>
            </Grid>
            <Grid item xs={3} md={2}>
              <Button
                variant="contained"
                fullWidth
                style={{
                  backgroundColor: addNewAccountLoading || _.isEmpty(inputEmail) || _.isEmpty(inputPassword) || _.isEmpty(inputConfirmPassword) || (inputPassword !== inputConfirmPassword) ? "grey" : "#00AB55"
                }}
                disabled={addNewAccountLoading ||_.isEmpty(inputEmail) || _.isEmpty(inputPassword) || _.isEmpty(inputConfirmPassword) || (inputPassword !== inputConfirmPassword)}
                onClick={() => handleConfirm()}
              >
                {
                  addNewAccountLoading ? (<CircularProgress size={20} style={{ color: 'white' }}/>)
                  :
                  (
                    <Typography style={{ color: "white" }}>Confirm</Typography>
                  )
                }
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>

      <Dialog open={openRemoveAccountDialog} fullWidth maxWidth='sm'>
        <DialogContent>
          <Grid container direction="row" style={{ paddingBottom: 16 }}>
            <Grid item xs={12}>
              <Typography style={{ fontWeight: 'bold', fontSize: 16 }}>Are you sure?</Typography>
            </Grid>
          </Grid>

          <Grid container direction="row">
            <Grid item xs={12}>
              <Typography>Are you sure to remove this account <span style={{ fontWeight: 'bold' }}>{removeAccountCompanyName}</span>?</Typography>
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions>
          <Grid container direction="row" justifyContent="flex-end" spacing={2}>
            <Grid item>
              <Button
                variant="contained"
                fullWidth
                style={{
                  backgroundColor: removeLoading ? "grey" : "black"
                }}
                disabled={removeLoading}
                onClick={() => {
                  setOpenRemoveAccountDialog(false)
                  setRemoveAccountCompanyName('')
                  setRemoveAccountUserID('')
                }}
              >
                <Typography style={{ color: 'white' }}>Close</Typography>
              </Button>
            </Grid>
            <Grid item>
              <Button
                variant="contained"
                fullWidth
                style={{
                  backgroundColor: removeLoading ? "grey" : "red"
                }}
                disabled={removeLoading}
                onClick={() => handleRemoveAccount()}
              >
                {
                  removeLoading ? (<CircularProgress size={20} style={{ color: "white" }}/>)
                  :
                  (
                    <Typography style={{ color: 'white' }}>Confirm Remove</Typography>
                  )
                }
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>

      <DialogLoading
        open={switchLoading}
      />
    </>
  );
}

export default Account;
